// src/config/app-menu.jsx
const Menu = [
  { is_header: true, title: 'Navigation' },
  { is_divider: true },

  { path: '/dashboard',        icon: 'bi bi-speedometer2',          title: 'Dashboard',         perm: 'dashboard:access' },
  { is_divider: true },

  { path: '/users',            icon: 'bi bi-person-fill',           title: 'Users',             perm: 'users:access' },
  { path: '/users/activity',   icon: 'bi bi-person-lines-fill',     title: 'User Activity',     perm: 'users:access' },
  { path: '/users/reviews',    icon: 'bi bi-chat-square-quote',     title: 'Reviews & Feedback', perm: 'users:access' },
  { is_divider: true },

  { path: '/hardware',         icon: 'bi bi-cpu',                   title: 'Hardware',          perm: 'hardware:access' },
  { is_divider: true },

  {
    path: '/recipes',
    icon: 'fas fa-glass-martini',
    title: 'Recipes',
    perm: 'recipes:access',
    children: [
      { path: '/recipes/recipesbyevent', title: 'Recipes per Event Counts' },
      { path: '/recipes/searchrecipes',  title: 'Search Recipes' },
      { path: '/recipes/latestrecipes',  title: 'Latest Recipes' },
      // { path: '/recipes/latestrecipespg',  title: 'Latest Recipes PostGreSQL' }
    ]
  },

  { is_divider: true },
  { path: '/ingredients',      icon: 'bi bi-menu-button-wide-fill', title: 'Ingredients',       perm: 'ingredients:access' },

  { is_divider: true },
  {
    path: '/googleanalytics',
    icon: 'fab fa-google',
    title: 'Barsys Analytics',
    perm: 'googleanalytics:access',
    children: [
      { path: '/googleanalytics/home',     icon: 'fas fa-chart-line', title: 'Home' },
      { path: '/googleanalytics/report',   icon: 'fas fa-chart-line', title: 'Report' },
      { path: '/googleanalytics/realtime', icon: 'fas fa-chart-line', title: 'Realtime' },
      { path: '/googleanalytics/bigquery', icon: 'fas fa-database', title: 'BigQuery Insights' }
    ]
  },

  { is_divider: true },
  {
    path: '/firebaseanalytics',
    icon: 'fab fa-google',
    title: 'Firebase Analytics',
    perm: 'firebaseanalytics:access',
    children: [
      { path: '/firebaseanalytics/home',     icon: 'fas fa-chart-line', title: 'Home' },
      { path: '/firebaseanalytics/report',   icon: 'fas fa-chart-line', title: 'Report' },
      { path: '/firebaseanalytics/realtime', icon: 'fas fa-chart-line', title: 'Realtime' },
      { path: '/firebaseanalytics/barsys-ai', icon: 'fas fa-mobile-alt', title: 'Barsys AI App (iOS / Android)' },
      { path: '/firebaseanalytics/all-apps', icon: 'fas fa-database', title: 'All Apps (BigQuery)' }
    ]
  },
  { is_divider: true },

  {
    path: '/webflowanalytics',
    icon: 'fab fa-google',
    title: 'Webflow Analytics',
    perm: 'webflowanalytics:access',
    children: [
      { path: '/webflowanalytics/home',     icon: 'fas fa-chart-line', title: 'Shaker Pro Home' },
      // { path: '/webflowanalytics/report',   icon: 'fas fa-chart-line', title: 'Report' },
      { path: '/webflowanalytics/realtime', icon: 'fas fa-chart-line', title: 'Shaker Pro Realtime' }
    ]
  },

  // { is_divider: true },

  {
    path: '/orders',
    icon: 'fa-solid fa-cart-shopping',
    title: 'E-Commerce',
    perm: 'orders:access',
    children: [
      {
        path: '/orders',
        title: 'Orders',
        perm: 'orders:access',
        children: [
          { path: '/orders/channel', title: 'Channel Orders', perm: 'orders:access' },
          { path: '/orders/manage',  title: 'Manage Orders',  perm: 'orders:access' },
          { path: '/orders/export',  title: 'Orders Export',  perm: 'orders:access' }
        ]
      },

      { is_divider: true },

      {
        path: '/orders/product-sales',
        title: 'Product Sales',
        perm: 'orders:access',
        children: [
          { path: '/orders/product-sales',          title: 'Channel Sales',    perm: 'orders:access' },
          { path: '/orders/product-sales-compare',  title: 'Sales Comparison', perm: 'orders:access' },
        ]
      },

      {
        path: '/orders/units-heatmap-by-state',
        title: 'Heatmap by State',
        perm: 'orders:access'
      },

      { is_divider: true },

      {
        path: '/orders/manage',
        title: 'Manage (Commerce Engine)',
        perm: 'orders:access',
        children: [
          { path: '/orders/products',  title: 'Products',  perm: 'orders:access' },
          { path: '/orders/taxonomy', title: 'Categories & Collections', perm: 'orders:access' },
          { path: '/orders/pages',     title: 'CMS Pages',  perm: 'orders:access' },
          { path: '/orders/discounts', title: 'Discounts (US)',  perm: 'orders:access' },
          { path: '/orders/india-discounts', title: 'Discounts (India)',  perm: 'orders:access' },
          { path: '/orders/revenue-bridge', title: 'Revenue bridge', perm: 'orders:access' }
        ]
      },
    ]
  },




  { is_divider: true },
  { path: '/ai',               icon: 'bi bi-robot',                 title: 'AI Chat Work In Progress', perm: 'ai:access' },

  { is_divider: true },
  { path: '/content',          icon: 'bi bi-body-text',             title: 'Content',           perm: 'content:access' },

  { path: '/dashboardadmindata', icon: 'fas fa-cogs',               title: 'Dashboard Admin',   perm: 'dashboardadmindata:access' }
];

export default Menu;
